import GitHubIcon from '@material-ui/icons/GitHub'
import LinkedInIcon from '@material-ui/icons/LinkedIn'
import { about } from '../../data'
import './About.css'

const About = () => {
  const { name, role, focus, social } = about

  return (
    <div className='about center'>
      <div className='about__availability' aria-label='Open to work'>
        <span className='about__availability-dot' />
        Open to work
      </div>

      {name && (
        <h1>
          Hi, I am <span className='about__name'>{name}.</span>
        </h1>
      )}

      {role && <h2 className='about__role'> {role}.</h2>}
      {focus && <p className='about__focus'>{focus}</p>}

      <div className='about__contact center'>
        {about.resume && (
          <a href={about.resume} target='_blank' rel='noreferrer' className='btn btn--outline'>
            Resume
          </a>
        )}
        {social && (
          <>
            {social.github && (
              <a
                href={social.github}
                aria-label='github'
                className='link link--icon'
                target='_blank'
                rel='noreferrer'
              >
                <GitHubIcon />
              </a>
            )}

            {social.linkedin && (
              <a
                href={social.linkedin}
                aria-label='linkedin'
                className='link link--icon'
                target='_blank'
                rel='noreferrer'
              >
                <LinkedInIcon />
              </a>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default About
